import Loadable from 'react-loadable'
import MainLayout from '../../components/layout/MainLayout'
import LoadingPage from '../../components/layout/Loading'


const PageMain = Loadable({
  loader: () => import('../../pages/routes/List_routes'),
  loading: LoadingPage,
})

const PageAction = Loadable({
  loader: () => import('../../pages/routes/Action'),
  loading: LoadingPage,
})

const Routes = [
  {
    path: '/routes',
    exact: true,
    requiredAuth: true,
    component: PageMain,
    layout: MainLayout,
  },
  {
    path: '/routes/action',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
  {
    path: '/routes/action/:id',
    exact: true,
    requiredAuth: true,
    component: PageAction,
    layout: MainLayout,
  },
]

export default Routes
